<kl-geo-multi-locations [allLocations]="allLocations"></kl-geo-multi-locations>
